import { render } from "./Game.vue?vue&type=template&id=7d73bbed&scoped=true&ts=true"
import script from "./Game.vue?vue&type=script&lang=ts"
export * from "./Game.vue?vue&type=script&lang=ts"

import "./Game.vue?vue&type=style&index=0&id=7d73bbed&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newD\\floor30-ws-with-server-selection\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d73bbed"]])

export default __exports__